import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=7156c1be&"
import script from "./ProgressBar.vue?vue&type=script&lang=ts&"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports